var map = {
	"./deluxe/studio.JPG": 276,
	"./executive/IMG_1480.jpg": 83,
	"./executive/IMG_1481.jpg": 910,
	"./general/MAS_7047.JPG": 21,
	"./general/MAS_7052.JPG": 495,
	"./general/MAS_7084.JPG": 806,
	"./general/MAS_7093.JPG": 438,
	"./general/MAS_7096.JPG": 663,
	"./general/MAS_7103-2.JPG": 673,
	"./general/building.JPG": 263,
	"./premium/premium1.JPG": 858,
	"./premium/premium2.JPG": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 237;